import * as React from "react";
import apiClients from "../../apiClients";
import * as Messages from "../../codegen/Messages";
import { parseId } from "../../helpers/idHelper";
import { useMutationCall } from "../../hooks/useMutationCall";
import {
  AsyncNotificationMethodKey,
  AsyncNotificationPolledResponseKey,
  MDS_RESTART_POLL_DELAY,
  MDS_RESTART_POLL_INTERVAL,
} from "../../models/AsyncNotificationProviders";
import { getOciRegion } from "../../utils";
import { OperationConfirmationProps } from "../OperationTypes";

export interface MysqlRestartProps extends OperationConfirmationProps {
  databaseId: string | undefined;
}

const MysqlRestart = (
  { location, databaseId, onExecute }: MysqlRestartProps,
): JSX.Element => {
  const { invokeCall: invokeRestart } = useMutationCall(
    { method: apiClients.withRegion(getOciRegion(location)).mdsDatabaseApi.restartMdsDbSystem },
  );

  React.useEffect(() => {
    const { subscriptionId, resourceGroup, resourceName } = parseId(databaseId);
    const resourceGroupName = decodeURIComponent(resourceGroup || "");
    const dbSystemName = decodeURIComponent(resourceName || "");

    const invokeOptions = {
      onSuccess: onExecute,
      notification: {
        inProgress: {
          title: Messages.notifications.inProgress.titles.restartMysql(),
          message: Messages.notifications.inProgress.messages.restartMysql(dbSystemName),
        },
        success: {
          title: Messages.notifications.success.titles.restartMysql(),
          message: Messages.notifications.success.messages.restartMysql(dbSystemName),
        },
        failure: {
          title: Messages.notifications.failure.titles.restart(),
          message: Messages.notifications.failure.messages.restartMysql(dbSystemName),
        },
        asyncPolling: {
          methodKey: AsyncNotificationMethodKey.MDS_GET,
          methodArgs: {
            subscriptionId,
            resourceGroupName,
            dbSystemName,
          },
          location,
          responseMethodKey: AsyncNotificationPolledResponseKey.MDS_RESTARTED_CHECK,
          delay: MDS_RESTART_POLL_DELAY,
          interval: MDS_RESTART_POLL_INTERVAL,
        },
      },
    };
    invokeRestart({
      subscriptionId,
      resourceGroupName,
      dbSystemName,
    }, invokeOptions);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return <div />;
};

export const newMysqlRestart = (
  props: MysqlRestartProps,
): JSX.Element => (<MysqlRestart {...props} />);
